import { render, staticRenderFns } from "./DeviceRedirect.vue?vue&type=template&id=0c5de460&scoped=true"
import script from "./DeviceRedirect.vue?vue&type=script&lang=js"
export * from "./DeviceRedirect.vue?vue&type=script&lang=js"
import style0 from "./DeviceRedirect.vue?vue&type=style&index=0&id=0c5de460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5de460",
  null
  
)

export default component.exports